import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=4553c6a4&scoped=true&"
import script from "./course-list.vue?vue&type=script&lang=js&"
export * from "./course-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553c6a4",
  null
  
)

export default component.exports